import _fp from 'lodash/fp';

export default _fp.convert({
  cap: false, // capture key on map(value, KEY)
});
